import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

export var ActionTypes = {
  RESET: 'RESET',
  LOAD_SUGGESTIONS_REQUEST: 'LOAD_SUGGESTIONS_REQUEST',
  LOAD_SUGGESTIONS_SUCCESS: 'LOAD_SUGGESTIONS_SUCCESS',
  LOAD_SUGGESTIONS_FAILURE: 'LOAD_SUGGESTIONS_FAILURE'
};
export var initialState = {
  isLoading: false,
  error: null,
  suggestions: {
    query: '',
    alternatives: []
  }
};
export default function createSearchSuggestionsReducer(_ref) {
  var query = _ref.query;
  return function searchReducer(state, action) {
    if (action.query !== query) {
      return state;
    }

    switch (action.type) {
      case ActionTypes.RESET:
        return initialState;

      case ActionTypes.LOAD_SUGGESTIONS_REQUEST:
        return _objectSpread(_objectSpread({}, state), {}, {
          isLoading: true
        });

      case ActionTypes.LOAD_SUGGESTIONS_SUCCESS:
        {
          return {
            isLoading: false,
            error: null,
            suggestions: _objectSpread({
              query: action.query
            }, action.payload)
          };
        }

      case ActionTypes.LOAD_SUGGESTIONS_FAILURE:
        return {
          isLoading: false,
          error: action.error,
          suggestions: {
            query: action.query,
            alternatives: []
          }
        };
    }
  };
}